import {
  isCcmModule,
  isCombinedModule,
  isRpmModule,
} from 'infrastructure/functions';

import type { ModuleType } from 'infrastructure/enums';

type TContext = {
  module: ModuleType;
  isMobileDevice: boolean;
};

type TGetIndex = {
  ccm?: number;
  rpm?: number;
  ccmRpm?: number;
  mob?: number;
  defaultIndex?: number;
};
export const getIndexByContext = ({ module, isMobileDevice }: TContext) => {
  return ({ ccm, rpm, ccmRpm, mob, defaultIndex }: TGetIndex) => {
    if (isMobileDevice) {
      return mob ?? defaultIndex;
    }
    if (isCcmModule(module)) {
      return ccm ?? defaultIndex;
    }
    if (isRpmModule(module)) {
      return rpm ?? defaultIndex;
    }
    if (isCombinedModule(module)) {
      return ccmRpm ?? defaultIndex;
    }

    return defaultIndex;
  };
};
